import React from 'react';

import { ArrowForward } from '@lyearn/icons';

import Stack from '../Stack';
import Typography from '../Typography';

const DateDisplay = ({
  className,
  endDate,
  placeholder,
  startDate,
}: {
  className?: string;
  endDate?: string;
  placeholder?: string;
  startDate?: string;
}) => {
  const renderDate = (date?: string) => (
    <Typography
      className={className}
      color={date ? 'text-text-primary' : 'text-text-placeholder'}
      variant="body-short-02">
      {date ? date : placeholder}
    </Typography>
  );

  return (
    <Stack alignItems="center">
      {renderDate(startDate)}
      {endDate ? (
        <>
          <ArrowForward className="w-16 h-16 text-icon-secondary mx-4 shrink-0" />
          {renderDate(endDate)}
        </>
      ) : null}
    </Stack>
  );
};

export default React.memo(DateDisplay);
